module.exports = __webpack_public_path__ + "static/loading-favicon-a9418083af70406c9643e5fe89ef1e7d.ico";